<script lang="ts">
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    export let index;
    export let max;

    function change(newPage: number) {
        if (max >= 0 && (newPage < 0 || newPage > max)) return;
        index = newPage;
        dispatch("change", index);
    }
    function changeRelative(shift: number) {
        change(index + shift);
    }
</script>

<div class="root">
    <div
        class="activeIcon inactiveIconPlus customIcon"
        class:activeIconDisabled={index === 0 || max < 0}
        on:click={() => changeRelative(-1)}
    >
        <span class="material-icons"> navigate_before </span>
    </div>
    <p>{max < 0 ? 1 : index + 1}</p>
    <div
        class="activeIcon inactiveIconPlus customIcon"
        class:activeIconDisabled={index === max || max < 0}
        on:click={() => changeRelative(1)}
    >
        <span class="material-icons"> navigate_next </span>
    </div>
</div>

<style>
    .root {
        display: flex;
        align-items: center;
    }
    .customIcon {
        margin: 5px 10px;
    }
    .customIcon > .material-icons {
        font-size: 1.6rem;
    }
</style>
